import { create } from 'zustand'
import { makeAutoObservable } from 'mobx'
import EmailModel from '../models/Email'

/** Zustand -- start **/

type ZustandEmailStore = {
  unreadEmailCount: number
  mailboxEmailAddress: string
  hasGraphHeaders: boolean
  setHasGraphHeader: (hasGraphHeaders: boolean) => void
  setUnreadEmailCount: (num: number) => void
  decrementUnreadEmails: () => void
  incrementUnreadEmails: () => void
  setMailboxEmailAddress: (email?: string) => void
}

// TODO: Replace with EmailStore (mobx)
const useEmailStore = create<ZustandEmailStore>((set) => ({
  mailboxEmailAddress: '',
  unreadEmailCount: 0,
  hasGraphHeaders: false,
  setHasGraphHeader: (hasGraphHeaders) => set({ hasGraphHeaders }),
  setUnreadEmailCount: (num) => set({ unreadEmailCount: num }),
  decrementUnreadEmails: () => set((state) => ({ unreadEmailCount: state.unreadEmailCount - 1 < 0 ? 0 : state.unreadEmailCount - 1 })),
  incrementUnreadEmails: () => set((state) => ({ unreadEmailCount: state.unreadEmailCount + 1 })),
  setMailboxEmailAddress: (email) => set((state) => ({ mailboxEmailAddress: email }))
}))

/** Zustand -- end **/

export default class EmailStore {
  public email: EmailModel | null = null

  // emails = new Map<string, Email>()
  mailboxEmailAddress: string = ''

  public setCurrentMailbox(email: string) {
    this.mailboxEmailAddress = email
  }

  constructor() {
    makeAutoObservable(this)
  }

  /**
   * TODO: Pull email from the store
   */
  async injectEmail(obj: MicrosoftEmail, mailbox?: string) {
    this.email = new EmailModel(obj, mailbox ?? this.mailboxEmailAddress)
    // list metadata without binary contents, so we can render the attachment list
    await this.email.loadAllAttachments()

    try {
      // lazy load the binary contents
      this.email.lazyLoadInlineAttachments()
    } catch (e) {
      console.info('failed to load inline attachments for email', obj, mailbox)
    }
  }
}

export { useEmailStore }
